export default __webpack_public_path__ + "static/media/check.e607a072.svg";